import React from 'react';
import './FilesViewerModal.scss';

/**
 * Universal modal for viewing attached files (PDFs, images)
 * Can be used for Users, Customers, Carriers, Payments, etc.
 */
const FilesViewerModal = ({ 
  isOpen, 
  onClose, 
  files = [], 
  images = [],
  title = 'Attached Files',
  entityName = ''
}) => {
  if (!isOpen) return null;

  const allFiles = [...(files || []), ...(images || [])];

  const handleFileClick = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };

  const getFileName = (url) => {
    if (!url) return 'Unknown file';
    try {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return decodeURIComponent(fileName) || 'File';
    } catch {
      return 'File';
    }
  };

  const getFileIcon = (url) => {
    if (!url) return '📄';
    const lower = url.toLowerCase();
    if (lower.endsWith('.pdf')) return '📕';
    if (lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.png') || lower.endsWith('.gif') || lower.endsWith('.webp')) return '🖼️';
    if (lower.endsWith('.doc') || lower.endsWith('.docx')) return '📘';
    if (lower.endsWith('.xls') || lower.endsWith('.xlsx')) return '📗';
    return '📄';
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="files-viewer-modal__backdrop" onClick={handleBackdropClick}>
      <div className="files-viewer-modal">
        {/* Header */}
        <div className="files-viewer-modal__header">
          <h2 className="files-viewer-modal__title">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14,2 14,8 20,8" />
            </svg>
            {title}
            {entityName && <span className="files-viewer-modal__entity-name"> - {entityName}</span>}
          </h2>
          <button className="files-viewer-modal__close-btn" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="files-viewer-modal__content">
          {allFiles.length === 0 ? (
            <div className="files-viewer-modal__empty">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14,2 14,8 20,8" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="15" y2="17" />
              </svg>
              <p>No files attached</p>
            </div>
          ) : (
            <div className="files-viewer-modal__list">
              {allFiles.map((fileUrl, index) => (
                <div 
                  key={index} 
                  className="files-viewer-modal__file"
                  onClick={() => handleFileClick(fileUrl)}
                >
                  <span className="files-viewer-modal__file-icon">
                    {getFileIcon(fileUrl)}
                  </span>
                  <span className="files-viewer-modal__file-name">
                    {getFileName(fileUrl)}
                  </span>
                  <span className="files-viewer-modal__file-action">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="files-viewer-modal__footer">
          <span className="files-viewer-modal__count">
            {allFiles.length} file{allFiles.length !== 1 ? 's' : ''}
          </span>
          <button className="files-viewer-modal__btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilesViewerModal;


